import React, { useEffect, useState } from 'react';
import { Countdown } from './Shared';
const VIEWER_SEQUENCE = [15, 16, 18, 23, 14, 12, 19, 21];
export const UrgencySection = () => {
  const [viewerIndex, setViewerIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setViewerIndex(prev => (prev + 1) % VIEWER_SEQUENCE.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <section id="precio-lanzamiento" className="bg-familia-bg border-t border-familia-cyan/30 py-6 md:py-9 px-4 md:px-6" data-id="element-283">
      <div className="max-w-3xl mx-auto text-center w-[92%] md:w-full" data-id="element-284">
        <h2 className="text-familia-red font-bold text-sm sm:text-lg md:text-xl mb-4 md:mb-6 animate-blink uppercase tracking-widest text-center" data-id="element-285">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>
        <Countdown className="mb-4 md:mb-6 scale-90" data-id="element-286" />
        <p className="text-familia-gray text-xs sm:text-sm md:text-base mb-4 md:mb-6 text-center" data-id="element-287">
          Después sube y no vuelve a bajar.
        </p>
        <div className="max-w-sm mx-auto bg-familia-card border border-familia-cyan/25 p-3 md:p-4 rounded-xl" data-id="element-288">
          <div className="flex justify-between items-center mb-3" data-id="element-289">
            <div className="flex items-center gap-2" data-id="element-290">
              <span className="w-1.5 h-1.5 bg-familia-red rounded-full animate-ping" data-id="element-291" />
              <span className="text-[10px] sm:text-xs font-bold" data-id="element-292">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-familia-red font-bold text-[10px] sm:text-xs" data-id="element-293">
              ¡Solo quedan 7 cupos!
            </span>
          </div>
          <div className="w-full bg-white/5 h-2 rounded-full overflow-hidden" data-id="element-294">
            <div className="bg-familia-cyan h-full w-[85%]" data-id="element-295" />
          </div>
        </div>
        <p className="font-sans font-bold text-[14px] text-center mt-4 max-w-sm mx-auto" style={{
        color: '#C0392B'
      }} aria-live="polite" data-id="element-296">
          🔥 {VIEWER_SEQUENCE[viewerIndex]} personas están viendo esta página
          ahora mismo
        </p>
      </div>
    </section>;
};